import * as angular from "angular";

const events = {
  newOrder: {
    orderPrice: 'create-new-order-price-changed'
  }
};

const packageTypeKeys = {
  NoPackage: {
    name: 'Envelope',
    description: 'Envelope',
    SVG: 'pack-envelope'
  },
  SmallPackage: {
    name: 'Small Box',
    description: 'Small Box 10x17x20',
    SVG: 'pack-box-small'
  },
  MediumPackage: {
    name: 'Medium Box',
    description: 'Medium Box 17x35x25',
    SVG: 'pack-box-med'
  },
  BigPackage: {
    name: 'Large Box',
    description: 'Large Box 19x49x25',
    SVG: 'pack-box-large'
  },
  SpecialPackage: {
    name: 'Special Package',
    description: 'Special Package',
    SVG: 'pack-special'
  },
  Other: {
    name: 'Other Package',
    description: 'Other Package',
    SVG: 'pack-other'
  },
  BasePack: {
    name: 'Base Package',
    description: 'Base Package',
    SVG: 'pack-base'
  },
  Extras: {
    name: 'Extras',
    description: 'Extras',
    SVG: 'pack-base'
  },
  FrozenPackage: {
    name: 'Frozen Package',
    description: 'Frozen Package',
    SVG: 'pack-freeze'
  },
  CooledPackage: {
    name: 'Cooled Package',
    description: 'Cooled Package',
    SVG: 'pack-cool'
  },
  Pallet: {
    name: 'Pallet',
    description: 'Pallet',
    SVG: 'pack-pallet'
  }
};

const identificationKeys = {
  signature: true,
  visitSummary: true,
  showIdCard: true,
  photographIdCard: true,
  photographPerson: true,
  leaveNextToDoor: true,
  validateIdCardNumber: true
};


angular
  .module('bringoz.admin.orders')
  .constant('orderConstants', {
    events: events,
    packageTypeKeys: packageTypeKeys,
    identificationKeys: identificationKeys
  });
